const STEPS = [
  {
    n: "01",
    icon: "ri-phone-line",
    title: "Apply & Talk to Admissions",
    body: "Fill out a short form or call 888-866-3428. We'll talk about your background, goals, and which track fits best.",
  },
  {
    n: "02",
    icon: "ri-calendar-check-line",
    title: "Enroll & Get Your Kit",
    body: "Lock in your seat, complete onboarding, and pick up your tool kit and laptop before day one.",
  },
  {
    n: "03",
    icon: "ri-tools-line",
    title: "Hands-On Bootcamp",
    body: "12–16 weeks of hands-on labs, real gear, small class sizes, and instructors who still work in the field.",
  },
  {
    n: "04",
    icon: "ri-briefcase-4-line",
    title: "Career Placement",
    body: "Resume, mock interviews, and direct intros to hiring partners looking for exactly your new skill set.",
  },
];

export default function Path() {
  return (
    <section id="path" className="relative bg-background-100 py-20 md:py-28">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-16">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-200 text-secondary-800 text-xs font-mono uppercase tracking-[0.2em] mb-4">
              <i className="ri-route-line"></i> How It Works
            </div>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-[1.05]">
              A straight path from
              <br />
              <span className="text-primary-600">"curious"</span> to <span className="text-primary-600">"hired."</span>
            </h2>
          </div>
          <p className="text-base md:text-lg text-foreground-700 max-w-md">
            No prerequisites. No wasted semesters. Just four clean steps from your first phone call
            to your first day on the job.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {STEPS.map((s, i) => (
            <div
              key={s.n}
              className="relative p-6 rounded-xl bg-background-50 border border-background-200 hover:border-primary-400 transition-colors"
            >
              <div className="flex items-center justify-between mb-5">
                <span className="font-mono text-xs text-foreground-500 tracking-[0.2em]">STEP {s.n}</span>
                <div className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className={`${s.icon} text-xl`} aria-hidden="true"></i>
                </div>
              </div>
              <h3 className="font-heading font-semibold text-lg text-foreground-950 mb-2">
                {s.title}
              </h3>
              <p className="text-sm text-foreground-700 leading-relaxed">{s.body}</p>
              {i < STEPS.length - 1 && (
                <i
                  className="ri-arrow-right-line hidden lg:block absolute -right-4 top-1/2 -translate-y-1/2 text-primary-500 text-2xl"
                  aria-hidden="true"
                ></i>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}